import { render, staticRenderFns } from "./RecipientsEmail.vue?vue&type=template&id=7251e28c&scoped=true"
import script from "./RecipientsEmail.vue?vue&type=script&lang=js"
export * from "./RecipientsEmail.vue?vue&type=script&lang=js"
import style0 from "./RecipientsEmail.vue?vue&type=style&index=0&id=7251e28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7251e28c",
  null
  
)

export default component.exports